import { Link } from "gatsby";
import gsap from "gsap";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import { SafeHtmlParser } from "./SafeHtmlParser";

const IconsLayout3 = ({ heading, items }) => {
	const handleMouseEnter = (e, colour) => {
		gsap.to(e.target, { color: colour, duration: 0.1 });
	};

	const handleMouseLeave = (e) => {
		gsap.to(e.target, { color: "#00304B", duration: 0.1 });
	};

	return (
		<section className="py-5 py-lg-7">
			<Container>
				{/* Heading */}
				<Row className="mb-5 mb-lg-7">
					<Col className="text-primary">
						<SafeHtmlParser htmlContent={heading} />
					</Col>
				</Row>

				{/* Services Grid */}
				<Row className=" g-4 g-xl-5">
					{items.map((item, index) => (
						<Col lg={3} md={6} key={index} className="">
							<div style={serviceItemStyles}>
								<img
									className="mb-3"
									src={item.icon.sourceUrl}
									alt={item.heading}
									style={iconStyles}
								/>

								<h4>{item.heading}</h4>

								<p>{item.body}</p>

								<div className="d-flex align-items-center">
									<Link
										className="outfit-regular text-decoration-none text-black mb-0 pb-0"
										to={item.url}
									>
										Learn More{" "}
									</Link>
									<span>
										<MdKeyboardArrowRight className="fs-5 ms-1 text-primary" />
									</span>
								</div>
							</div>
						</Col>
					))}
				</Row>
			</Container>
		</section>
	);
};

const serviceItemStyles = {
	textAlign: "left",
};

const iconStyles = {
	width: "50px",
	height: "50px",
};

const listStyles = {
	listStyleType: "none",
};

export default IconsLayout3;
